/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to use it`)
};

const es_ue_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo usarlo`)
};

const de_ue_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie man es benutzt`)
};

const nl_ue_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe te gebruiken`)
};

const fr_ue_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment l'utiliser`)
};

const it_ue_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come usarlo`)
};

const pt_br2_ue_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como usar`)
};

const pt_ue_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como utilizar`)
};

const ja_ue_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使い方`)
};

const zh_ue_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用方法`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_howto_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_howto_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_howto_title", locale)
	if (locale === "en") return en_ue_howto_title(inputs)
	if (locale === "es") return es_ue_howto_title(inputs)
	if (locale === "de") return de_ue_howto_title(inputs)
	if (locale === "nl") return nl_ue_howto_title(inputs)
	if (locale === "fr") return fr_ue_howto_title(inputs)
	if (locale === "it") return it_ue_howto_title(inputs)
	if (locale === "pt-BR") return pt_br2_ue_howto_title(inputs)
	if (locale === "pt") return pt_ue_howto_title(inputs)
	if (locale === "ja") return ja_ue_howto_title(inputs)
	return zh_ue_howto_title(inputs)
};